import { ArrowUpRight } from "lucide-react";
import { IMAGES, TRADE_TOPICS, imgUrl } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function Trade() {
  return (
    <section id="trade" data-testid="trade-section" className="grain bg-atlantic py-24 lg:py-32">
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              dark
              chapter="07"
              kicker="Trade, Enterprise and Innovation"
              title="From Symbolism to Supply Lines"
              copy="Coverage of the practical infrastructure of cooperation — routes, markets, technology and investment."
            />
            <div className="relative mt-12 overflow-hidden">
              <img
                src={imgUrl(IMAGES.tech, 1000)}
                alt="Professional working on technology across the Atlantic"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
              />
            </div>
          </div>
          <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.28em] text-white/50">Coverage Areas</p>
            <div>
              {TRADE_TOPICS.map((t, i) => (
                <a
                  key={t}
                  href="#contact"
                  data-testid={`trade-topic-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group flex items-center justify-between border-b border-white/10 py-5 transition-colors first:border-t hover:bg-white/5"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="font-serif text-sm text-gold">{String(i + 1).padStart(2, "0")}</span>
                    <span className="font-serif text-lg text-white transition-colors group-hover:text-gold sm:text-xl">{t}</span>
                  </span>
                  <ArrowUpRight size={16} className="text-white/35 transition-colors group-hover:text-gold" />
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
